import { PageScroll } from '@/layouts/page-layout';
import BuilderSettingsWidget from './builder-settings-widget';
import BalanceCardsSettingsWidget from './balance-cards-settings-widget';
import PhotosAiSettingsWidget from './photos-ai-settings-widget';
import ContactBroadcastSettingsWidget from './contact-broadcast-settings-widget';
import DomainSettingsWidget from './domain-settings-widget';
import LandingsReleaseWidget from './landings-release-widget';
import LandingsSettingsWidget from './landings-settings-widget';
import SenderSettingsWidget from './sender-settings-widget';
import CardFillSettingsWidget from './card-fill-settings-widget';

export default function AdminSettingsPage() {
	return (
		<PageScroll contentClassName='p-2 flex flex-col gap-4'>
			<p className='text-sm text-muted-foreground -mt-1 mb-1'>Управление модулями и параметрами системы</p>
			<div className='flex flex-col gap-4'>
				<BuilderSettingsWidget />
				<ContactBroadcastSettingsWidget />
				<BalanceCardsSettingsWidget />
				<PhotosAiSettingsWidget />
				<DomainSettingsWidget />
				<LandingsSettingsWidget />
				<SenderSettingsWidget />
				<CardFillSettingsWidget />
				<LandingsReleaseWidget />
			</div>
		</PageScroll>
	);
}
